import {CrudModel} from '@ngx-ivengi/crud';
import {IFormSelectOption} from '@brands-compart/form-wizard';
import {Floor} from '../floor/floor.model';

export class Room extends CrudModel implements IFormSelectOption {

  public name: string;
  public floor: Floor;

  public setName(name: string): Room {
    if(typeof name === 'string') {
      this.name = name;
    }
    return this;
  }

  public setFloor(floor: Floor): Room {
    if(floor instanceof Floor) {
      this.floor = floor;
    }
    return this;
  }

  fromResponse(response: any): void {
    if(response) {
      this
        .setId(response.id)
        .setName(response.name);

      if(response.floor) {
        const floor = new Floor();
        floor.fromResponse(response.floor);
        this.setFloor(floor);
      }

    }
  }

  toKeyValueOption(): {label: string; value: any} {
    return {
      label: this.name,
      value: this.id
    };
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/room/room.model.ts